import { useEffect, useState } from 'react';
import { useStore } from 'zustand';
import { FuelType } from '../../../types';
import { fetchWithType } from '../../../utils/api';
import {
  getAdminUrl,
  getApiToken,
  locationIsKia,
} from '../../../utils/helpers';
import { getStoreByKey } from './store/CarouselStore';
import { activeButtonClasses, buttonClasses } from './types/CarouselTypes';

const CarouselFuels = ({ uniqId }: { uniqId: string }) => {
  const [fuels, setFuels] = useState<FuelType[]>([]);
  const { dispatch, selectedFuels } = useStore(getStoreByKey(uniqId));

  const fetchFuelTypes = async () => {
    try {
      const { data } = await fetchWithType<FuelType[]>(
        getAdminUrl() + '/api/types',
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${getApiToken()}`,
          },
        },
      );
      if (data && data.length) {
        setFuels(data);
        if (!locationIsKia()) {
          sessionStorage.setItem('kia-carousel-fuels', JSON.stringify(data));
        }
      }
    } catch (error) {
      console.error('Error fetching fuel types:', error);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem('kia-carousel-fuels')) {
      setFuels(
        JSON.parse(sessionStorage.getItem('kia-carousel-fuels') || '[]'),
      );
    } else {
      fetchFuelTypes();
    }
  }, []);

  return (
    <>
      <button
        onClick={() => dispatch({ type: 'FUEL', payload: [] })}
        className={`${buttonClasses} ${!selectedFuels.length ? activeButtonClasses : null}`}
      >
        Alla
      </button>
      {fuels.map((fuel: FuelType) => (
        <button
          key={fuel.id}
          className={`${buttonClasses} ${selectedFuels.includes(fuel.id) ? activeButtonClasses : null}`}
          onClick={() => dispatch({ type: 'FUEL', payload: [fuel.id] })}
        >
          {fuel.name}
        </button>
      ))}
    </>
  );
};

export default CarouselFuels;
